module.exports = __webpack_public_path__ + "static/media/beer.0ba898b0.jpg";